// A BOOK THAT LOST ITS PAGES MUST NOT PRINT (2026-10-30, #WA-408838).
//
// 31 of Inès's 35 pages were emptied (photos: [], elements: []) after her
// second PDF's pages were marked duplicates, and the render printed 31 white
// pages without a word: an empty page is a valid page. One or two empty pages
// can be on purpose (a « Page blanche » for notes); a quarter of the book is
// not. The render stops and names the count instead.
//
// Guard: emptyPages.test.ts

interface PageLike {
  photos?: unknown;
  elements?: unknown;
  template_id?: unknown;
}

/** A page with nothing to print: no photo, no element, no template. Pure. */
export function isEmptyPage(p: PageLike | null | undefined): boolean {
  if (!p) return true;
  const photos = Array.isArray(p.photos) ? p.photos.filter(Boolean) : [];
  const elements = Array.isArray(p.elements) ? p.elements : [];
  return photos.length === 0 && elements.length === 0 && !p.template_id;
}

/** Null when the book is fine, else the error to stop the render with. Pure. */
export function emptyPagesProblem(pages: ReadonlyArray<PageLike | null | undefined>): string | null {
  const empty = pages.filter(isEmptyPage).length;
  if (empty <= 2 || empty * 4 < pages.length) return null;
  return `${empty} pages vides sur ${pages.length} — l'album a perdu ses photos, rendu arrêté (rien n'est imprimé vide)`;
}
